import React, { useEffect, useState } from "react";
import { Card, ListGroup, Badge, Placeholder, Spinner } from "react-bootstrap";
import { LuTriangleAlert } from "react-icons/lu";
import UrgentUpdateSkeleton from "../../../Components/Skeleton/UrgentUpdateSkeleton";
import MainCard from "../../../Components/Cards/MainCard";

const UrgentUpdates = () => {
  const [updates, setUpdates] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Simulate API Call
  useEffect(() => {
    setTimeout(() => {
      setUpdates([
        {
          title: "Agent Application",
          description: "5 new agent applications pending review",
          priority: "high",
          badgeColor: "primary",
        },
        {
          title: "Support Ticket",
          description: "Payment issue escalated - requires immediate attention",
          priority: "urgent",
          badgeColor: "danger",
        },
        {
          title: "System Alert",
          description: "Server maintenance scheduled for tonight",
          priority: "medium",
          badgeColor: "secondary",
        },
      ]);
      setLoading(false);
    }, 2000); // 2 sec delay fake API
  }, []);

  return (
    <MainCard>
      {/* Header */}
      <Card.Header className="fw-bold d-flex justify-content-start align-items-center rounded-3 bg-white border-0 mb-3 fs-4 gap-2 px-0">
        <LuTriangleAlert className="text-warning" />
        Urgent Updates
      </Card.Header>

      {/* List Items */}
      <ListGroup className="d-flex flex-column gap-3">
        {loading ? (
          // Skeleton Loader
          <UrgentUpdateSkeleton />
        ) : updates && updates.length > 0 ? (
          updates.map((item, index) => (
            <ListGroup.Item
              key={index}
              className="d-flex justify-content-between align-items-start border-1 border-light-subtle rounded-4 small"
            >
              <div>
                <div className="fw-bold">{item.title}</div>
                <small className="text-muted">{item.description}</small>
              </div>
              <Badge bg={item.badgeColor} pill className="px-2 py-1">
                {item.priority}
              </Badge>
            </ListGroup.Item>
          ))
        ) : (
          // Empty state (no data)
          <div className="text-center text-muted py-4">
            <Spinner animation="border" size="sm" className="me-2" />
            No urgent updates available
          </div>
        )}
      </ListGroup>
    </MainCard>
  );
};

export default UrgentUpdates;
